import { Alert, Box, useTheme } from "@mui/material";
import * as React from "react";

import { useAuth } from "@/providers";
import { SearchResults } from "@/Search/SearchResults";
import { useDeviceFiles } from "@/shared/domain/devices/hooks/useDeviceFiles";

interface DeviceFilesProps {
  deviceId: string;
}

export function DeviceFiles({ deviceId }: DeviceFilesProps) {
  const theme = useTheme();
  const { currentOrganization } = useAuth();
  const [lastError, setLastError] = React.useState<Error | null>(null);

  const { data: queryId, error } = useDeviceFiles(
    deviceId,
    currentOrganization?.org_id,
  );

  if (error) {
    return (
      <Box mt={theme.spacing(1)} mb={theme.spacing(2)}>
        <Alert severity="error">
          Failed to load files for device {deviceId}: {error.message}
        </Alert>
      </Box>
    );
  }

  return (
    <Box mt={theme.spacing(-1)} mb={theme.spacing(2)}>
      <SearchResults
        queryId={queryId}
        lastError={lastError}
        onError={setLastError}
      />
    </Box>
  );
}
